import Helpers from '@Apis/helpers';
import { entityNameEnum } from '@Apis/constants';

export const initialState = {
  isUserReady: false,
  currentUpdate: '',
  isGetAttachment: false,
  showNewStForm: false,
  showStockTransferModal: false,
  showCreateRfqDrawer: false,
  showPIForm: false,
  showPIDrawer: false,
  selectedPIId: null,
  selectedSTId: null,
  fileList: [],
  cfPurchaseRequestLine: null,
  selectedTags: [],
  isUserReadyForPrefillData: false,
  currentPrId: null,
  visibleColumns: {
    PRODUCT: { label: 'PRODUCT', visible: true, disabled: true },
    QUANTITY: { label: 'QUANTITY', visible: true, disabled: true },
    TARGET_PRICE: { label: 'TARGET PRICE', visible: true, disabled: true },
    PURCHASED: { label: 'PURCHASED', visible: true, disabled: true },
    TRANSFERRED: { label: 'TRANSFERRED', visible: true, disabled: true },
  },
};

export const handleFileChange = ({ fileList: fileListData, file }, selectedPurchaseRequest, updateAttachment, getAttachmentById, setState) => {
  const attachments = fileListData.map((item) => ({
    url: item?.response?.response?.location || item?.url,
    type: item.type,
    name: item.name,
    uid: item.uid,
  }));

  const payload = {
    entity_id: selectedPurchaseRequest?.purchase_requisition_id,
    entity_name: 'purchase_requisition',
    attachments,
  };

  if (["done", "removed"].includes(file?.status)) {
    updateAttachment(payload, () => {
      getAttachmentById(payload.entity_id, payload.entity_name, () => {
        setState((prev) => ({ ...prev, isGetAttachment: true }));
      });
    });
  }

  setState((prev) => ({
    ...prev,
    fileList: attachments.length > 0 ? attachments : [],
  }));
};

export const getLinkedDocumentInfo = (selectedPurchaseRequest, user, isQuickView, showPIDrawer, showStockTransferModal, setState, isDataMaskingPolicyEnable, isHideCostPrice) => {
  const linkedDocumentsInfo = [];

  if (selectedPurchaseRequest?.reference_rfq?.length > 0) {
    const documentDataInfo = selectedPurchaseRequest.reference_rfq.map(item => ({
      documentId: item?.rfq_id,
      documentNumber: item?.rfq_number,
      documentStatus: item?.status,
      documentTotal: item?.rfq_total,
    }));

    linkedDocumentsInfo.push({
      entityName: entityNameEnum.REQUEST_FOR_QUOTATION,
      title: 'REQUEST FOR QUOTE',
      entityNumberPrefix: 'RFQ',
      documentData: documentDataInfo,
      isRedirect: true,
      redirectPath: '/purchase/rfq/view/',
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.REQUEST_FOR_QUOTATION, Helpers.permissionTypes.READ, user) && documentDataInfo.length > 0,
      showEntityTotal: false,
    });
  }

  if (selectedPurchaseRequest?.reference_purchase_orders?.length > 0) {
    const documentDataInfo = selectedPurchaseRequest.reference_purchase_orders.map(item => ({
      documentId: item?.po_id,
      documentNumber: item?.po_number,
      documentStatus: item?.status,
      documentTotal: item?.po_grand_total,
    }));

    linkedDocumentsInfo.push({
      entityName: entityNameEnum.PURCHASE_ORDER,
      title: 'PURCHASE ORDERS',
      entityNumberPrefix: 'PO',
      documentData: documentDataInfo,
      isRedirect: true,
      redirectPath: '/approval?type=po&id=',
      hidePrice: isDataMaskingPolicyEnable && isHideCostPrice,
      popOverMessage: "You don't have access to view amount",
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ, user) && documentDataInfo.length > 0,
      showEntityTotal: true,
    });
  }

  if (selectedPurchaseRequest?.reference_purchase_indents?.length > 0) {
    const documentDataInfo = selectedPurchaseRequest.reference_purchase_indents.map(item => ({
      documentId: item?.pi_id,
      documentNumber: item?.pi_number,
      documentStatus: item?.status,
    }));

    linkedDocumentsInfo.push({
      entityName: entityNameEnum.PURCHASE_INDENT,
      title: 'PURCHASE INDENT',
      entityNumberPrefix: 'PI',
      documentData: documentDataInfo,
      isRedirect: isQuickView,
      isDrawer: !isQuickView,
      redirectPath: '/purchase/purchase-indent/view/',
      drawerState: showPIDrawer,
      drawerCallback: (pi, isOpen) => setState(prev => ({ ...prev, selectedPIId: pi?.documentId, showPIDrawer: isOpen })),
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.READ, user) && documentDataInfo.length > 0,
    });
  }

  if (selectedPurchaseRequest?.reference_stock_transfers?.length > 0) {
    const documentDataInfo = selectedPurchaseRequest.reference_stock_transfers.map(item => ({
      documentId: item?.stock_transfer_id,
      documentNumber: item?.stock_transfer_number,
      documentStatus: item?.status,
    }));

    linkedDocumentsInfo.push({
      entityName: entityNameEnum.STOCK_TRANSFER,
      title: 'STOCK TRANSFERS',
      entityNumberPrefix: 'ST',
      documentData: documentDataInfo,
      isRedirect: isQuickView,
      isDrawer: !isQuickView,
      drawerState: showStockTransferModal,
      drawerCallback: (st, isOpen) => setState(prev => ({ ...prev, selectedSTId: st?.documentId, showStockTransferModal: isOpen })),
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.READ, user) && documentDataInfo.length > 0,
    });
  }

  return linkedDocumentsInfo;
};
